module.exports = __webpack_public_path__ + "img/quest_icon_0004_potion.445cf064.png";